import { render, staticRenderFns } from "./popup_distribute_access_rights.vue?vue&type=template&id=d462158e&scoped=true&"
import script from "./popup_distribute_access_rights.vue?vue&type=script&lang=ts&"
export * from "./popup_distribute_access_rights.vue?vue&type=script&lang=ts&"
import style0 from "./popup_distribute_access_rights.vue?vue&type=style&index=0&id=d462158e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d462158e",
  null
  
)

export default component.exports